module.exports = __webpack_public_path__ + "static/bg-cookie-bot-f57373127bd8be079efe787965335272.png";